import { Box, Typography } from '@mui/material'
import useParseText from 'common/hooks/useParseText'
import { selectPortal } from 'features/portal/portalSlice'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const MsgBienvenida = () => {
  const portal = useSelector(selectPortal)
  const { response, error, loading } = useParseText(portal?.portal?.parametros_seo?.msg_bienvenida)

  const [msgBienvenida, setMsgBienvenida] = useState(null)

  useEffect(() => {
    if (response) {
      setMsgBienvenida(response?.text)
    }
  }, [response])

  return error ? (
    <></>
  ) : loading ? (
    <></>
  ) : (
    <Box>
      {msgBienvenida ? (
        <div
          dangerouslySetInnerHTML={{
            __html: msgBienvenida,
          }}
        />
      ) : (
        <>
          <Typography variant="h3" className="lighter">
            ¡Bienvenido
          </Typography>
          <Typography variant="h5" className="lighter">
            al portal del Empleado!
          </Typography>
        </>
      )}
    </Box>
  )
}

export default MsgBienvenida
